// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import axios from 'axios' // 处理http请求
import store from 'store' // 状态管理
import VueLazyload from 'vue-lazyload' // 懒加载
import VueResource from 'vue-resource';

import VueAwesomeSwiper from 'vue-awesome-swiper'
import '../node_modules/swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

/**
 * @desc 懒加载配置
 * @author wtniu
 */
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: './assets/error.jpg',
  loading: './assets/loading.gif',
  attempt: 1
})
Vue.use(VueResource)

Vue.prototype.baseUrl = Vue.config.devtools ? 'https://wfcquae.swuee.com/sync/' : 'https://wfcquae.swuee.com/sync/';
Vue.prototype.$axios = axios

// 去掉开发环境打印信息
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router ,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js